import { createSelector } from 'reselect'

import { selectSuggestedUsers } from 'selectors/users'
import { selectCurrentTicket } from 'selectors/tickets'
import { pick } from 'util/objects'

import { selectReplyRecipient, selectAllRecipientIds } from './recipients'

const selectPossibleReplyRecipientsExtractor = createSelector(
  selectReplyRecipient,
  replyRecipient => {
    return ticket => {
      if (!ticket) return []

      const customer = ticket.customer
      const emails = {}
      // NOTE (jscheel): Use object to prevent duplicates by id. DO NOT RETURN
      // THIS OBJECT! YOU SHOULD BE RETURNING Object.values(recipients).
      const recipients = {}

      if (
        customer &&
        replyRecipient &&
        customer.email !== replyRecipient.email
      ) {
        recipients[customer.id] = customer
      }

      if (!ticket.full) return Object.values(recipients) // ticket needs to be loaded

      if (customer) emails[customer.email] = true
      if (replyRecipient) emails[replyRecipient.email] = true
      const actions = ticket.actions || {}
      const records = actions.records || []
      records.forEach(action => {
        if (action.change_type === 'Message' && action.change) {
          ;['cc', 'bcc'].forEach(type => {
            ;(action.change[type] || []).forEach(cc => {
              const recipient = pick(['id', 'name', 'email'], cc)
              recipients[recipient.id] = recipient
            })
          })
        }
        const actor = action.actor
        if (!actor) return
        if (actor.type === 'Agent' || actor.type === 'Rule') return
        if (emails[actor.email]) return
        recipients[actor.id] = {
          id: actor.id,
          email: actor.email,
          name: actor.name,
        }
        emails[actor.email] = true
      })

      return Object.values(recipients)
    }
  }
)

export const selectPossibleReplyRecipients = createSelector(
  selectCurrentTicket,
  selectPossibleReplyRecipientsExtractor,
  (ticket, extractor) => extractor(ticket)
)

export const selectCurrentSuggestedRecipients = createSelector(
  selectPossibleReplyRecipients,
  selectSuggestedUsers,
  selectAllRecipientIds,
  (possibleRecipients, suggestedUsers, allRecipientIds) => {
    const retVal = possibleRecipients.filter(possibleRecipient => {
      return allRecipientIds.indexOf(possibleRecipient.id) === -1
    })
    if (retVal.length > 0) {
      return retVal
    }
    return suggestedUsers
  }
)
